import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import { CenterModal, ModalFooter } from 'shared/components';
import { Button, Icon, Text } from 'shared/components/ui';
import { clearTokens, useLogoutUserMutation } from 'services';
import { PROGAI_EMAIL } from 'shared/utils';

import styles from './index.module.scss';

interface Props {
	className?: string;
}

export const ExpiredPlanModal: FC<Props> = ({ className }: Props) => {
	const navigate = useNavigate();

	const handleUpgrade = () => {
		navigate('/registration/plan');
	};

	const handleClose = () => {};

	const [logoutUser] = useLogoutUserMutation();

	const handleLogout = () => {
		logoutUser().then(() => {
			clearTokens();
			navigate('/login');
		});
	};

	return (
		<CenterModal
			onClose={handleClose}
			className={cn(styles.modal, className)}
			title="To continue using Prog.AI, please upgrade">
			{/* <Text>You can upgrade to a paid plan or contact us to request a free trial.</Text> */}
			<ModalFooter className={styles.footer}>
				<Button
					type="ghost"
					className={styles.footerLogout}
					onClick={handleLogout}
					prefix={<Icon icon="person" className={styles.footerLogoutIcon} />}>
					Logout
				</Button>
				<div className={styles.footerButtons}>
					<Button type="default" component="a" href={`mailto:${PROGAI_EMAIL}`}>
						Contact us
					</Button>
					<Button type="primary" onClick={handleUpgrade}>
						Select plan
					</Button>
				</div>
			</ModalFooter>
		</CenterModal>
	);
};
